/* eslint-disable */
import { createSelector } from 'reselect';
import getFilters from './Filters.selector';

/**
 * Selects the `orderStatus` from `filters`
 * @param {any} state The state
 * @returns {Array<OrderEntityStatus>} The `orderStatus` filter
 */
const getFiltersStatuses = createSelector(getFilters, (filters) => filters.orderStatus);

export default getFiltersStatuses;
